<template>
  <div>
    <span v-if="title">
      {{ title }}
    </span>

    <social-share-buttons :sharing="sharing" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SocialShareButtons from './social-share-buttons'

export default {
  components: { SocialShareButtons },

  props: {
    title: {
      type: String,
      required: false,
      default: null
    }
  },

  computed: {
    ...mapState(['sharing'])
  }
}
</script>
